import HideIcon from "@assets/icons/new/hide_24px.svg?react";
import ShowIcon from "@assets/icons/new/show_24px.svg?react";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { neutral } from "@flat-ui";

interface Props {
  /** Whether password is visible or hidden */
  isVisible: boolean;

  /** Callback when button is clicked */
  onClick: () => void;
}

/** Renders the button to show or hide the password input */
export function PasswordInputButton({
  isVisible,
  onClick,
}: Props): JSX.Element {
  return (
    <SphereIconButton
      component={isVisible ? HideIcon : ShowIcon}
      onClick={onClick}
      color={neutral[400]}
      buttonSize="24px"
      iconSize="18px"
    />
  );
}
